// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"BBHTML_fullscreen__2ae4M","fullwindow":"BBHTML_fullwindow__R6RJt"};